export { Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from './table';
